import { useEffect, useReducer, useState } from "react";
import useDataEvent from "./CustomHook";
import MainStore from "./MainStore";
import Panel from "./Panel";
import { PrimitiveCard } from "./PrimitiveCard";
import FeedList from "./@components/Feed";
import { HeroIcon } from "./HeroIcon";
import {DescriptionList, DescriptionTerm, DescriptionDetails} from './@components/description-list'
import { FlowInstanceInfo } from "./FlowInstanceInfo";
import { FlowInstanceOutput } from "./FlowInstanceOutput";
import clsx from "clsx";
import { VFImage } from "./VFImage";
import { useLocation, useParams } from "react-router-dom";
import Tabs from "./@components/tabs";
import { ClockIcon, SparklesIcon } from "@heroicons/react/24/outline";

const tabs = [
  { name: 'Inputs', id: "input" },
  { name: 'Progress', id: "progress"},
]

export default function WorkflowCard({primitive, className,...props}){
    const color = primitive.workspace?.color || "slate"
    const title = primitive?.title ?? "Untitled flow"
    const oneLine = primitive?.referenceParameters?.one_line ?? primitive?.referenceParameters?.description ?? ""
    const version = primitive?.published?.version
        ?? (primitive?.published ? 1 : null)
        ?? primitive?.replication?.sourceVersion
        ?? (primitive?.replication?.source ? 1 : null)
        ?? null
    const childImagePrimitive = (
        primitive?.primitives?.allUniqueElement
        ?? primitive?.primitives?.origin?.allUniqueElement
        ?? primitive?.primitives?.origin?.allElement
        ?? primitive?.primitives?.origin?.allUniqueItems?.filter((item)=>item?.type === "element")
        ?? []
    ).find((item)=>item?.referenceParameters?.hasImg || item?.imageCount)
    const imagePrimitive = childImagePrimitive ?? primitive
    const showImage = Boolean(
        imagePrimitive?.referenceParameters?.hasImg
        || imagePrimitive?.imageCount
    )
    const imageSrc = showImage ? `/api/image/${imagePrimitive.id}${imagePrimitive?.imageCount ? `?${imagePrimitive.imageCount}` : ""}` : undefined

    return <div onClick={props.onClick} className={clsx([
        "bg-white rounded-lg w-96 h-72 flex flex-col relative shadow-sm border font-['Poppins'] @container flex flex-col min-h-0 overflow-hidden",
        className,
        props.onClick ? "hover:shadow-lg hover:border-gray-300" : ""
    ])}>
                    {props.showVersionBadge && version !== null && version !== undefined && (
                        <div className="absolute right-3 top-3 z-10 rounded-full bg-white/95 px-2 py-1 text-xs font-semibold text-slate-700 shadow-sm ring-1 ring-black/5">
                            v{version}
                        </div>
                    )}
                    <div className={clsx([
                        "flex relative mb-4 min-h-48 max-h-48",
                        ])}>
                        {showImage && <VFImage 
                                            src={imageSrc} 
                                            className={clsx([
                                                'w-full object-cover ',
                                            ])}
                                        />}
                        {!showImage && <div className={clsx([
                            "w-full",
                            `pattern-isometric pattern-${color}-600 pattern-bg-${color}-500 pattern-opacity-20 pattern-size-8`
                        ])}/>}

                        <div className={
                            clsx([
                                "grow bottom-0 absolute py-2 px-3",
                                showImage ? "bg-gradient-to-t from-black to-transparent from-20% w-full text-white/80 pt-4" : "text-slate-700"
                            ])}>
                            <div className="text-lg font-semibold line-clamp-2">{title}</div>
                        </div>
                </div>
                <div className="p-3 grow flex flex-col text-slate-700">
                    <div className="text-sm font-medium line-clamp-1">{title}</div>
                    <div className="mt-1 text-sm font-light line-clamp-3 text-slate-600">
                        {oneLine || "No summary available"}
                    </div>
                </div>
                <div className="px-3 py-2 text-sm grow flex text-xs text-slate-500 justify-between">
                    <div className="flex space-x-1 place-items-center">
                        <SparklesIcon className="w-4 h-4"/>
                        <p className="font-semibold">Credits:</p><p className="text-slate-700">{primitive.referenceParameters.credits}</p>
                    </div>
                    <div className="flex space-x-1 place-items-center">
                        <ClockIcon className="w-4 h-4"/>
                        <p className="text-slate-700">{primitive.referenceParameters.duration}</p>
                    </div>
                </div>
    </div>
}
